import AnimationComponent from "Component/Animation";
import Interactable from "Component/Interactable";
import Renderable from "Component/Renderable";
import TransformComponent from "Component/Transform";
import GameObject from "GameObject/GameObject";
import Sprite from "Prototype/Sprite";
import Point from "Utility/Point";

export default class LuckyWheel extends GameObject {
    private wheelBody: Sprite;

    protected onCreate(params: any): void {
        this.addComponent<TransformComponent>(TransformComponent, params);

        this.addComponent<Renderable>(Renderable, params);

        this.addComponent<Interactable>(Interactable, { buttonMode: params.buttonMode });

        this.addComponent<AnimationComponent>(AnimationComponent, {
            playOnStart: false,
        });

        this.wheelBody = GameObject.Instantiate(Sprite, {
            visible: true,
            name: 'wheelBody',
            texture: 'wheel_body',
            anchor: new Point(0.5, 0.5),
        });

        const wheelNeedle = GameObject.Instantiate(Sprite, {
            name: 'wheelNeedle',
            texture: 'wheel_needle',
            anchor: new Point(0.44, 0.55),
            x: 0,
            y: -15,
        });

        this.wheelBody.addChild(wheelNeedle);

        this.addChild(this.wheelBody);
    }

    public getWheelBody(): Sprite {
        return this.wheelBody;
    }
}
